export const PencilIcon = ({ height = 16, width = 16 }) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 12 12"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7789 0.809998L2.05026 6.54016L1.74875 9.37508L4.52262 9.07349L10.2513 3.28301C9.52764 2.61952 9.46734 2.49889 7.7789 0.809998Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.125"
      />
      <path
        d="M11 11H1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.125"
      />
    </svg>
  );
};
